import { StatsUnit } from './enums/stats-unit.enum';

export class StatsButton {
  constructor(public query: string, public key: string, public titleKey: string, public value?: number, public unit?: StatsUnit, public precision = 0) {}
}
